import React, { useState, useEffect } from 'react';
import { editHolderFirm, deleteHolderFirm } from '../../store/actions/UserAction';
import { storage } from '../../configs/environments/firebase/firebaseApp';
import { validationAddingHolder } from '../../utils/validations';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import { makeStyles } from '@material-ui/styles';
import HolderForm from './HolderForm';
import Popup from '../Modal/PopUp';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { isMobile } from 'react-device-detect';
import './addHolders.scss';

/* Scroll */
var Scroll = require('react-scroll');
//var scroll = Scroll.animateScroll;
var scroller = Scroll.scroller;
// var ElementScroll = Scroll.Element;

function EditHolder(props) {
  const {
    uid,
    elements,
    evento,
    item,
    allHolders,
    editHolderFirm,
    deleteHolderFirm,
    setFlagEdit,
    trophie,
    alreadyRewarded,
    handleRewarded,
    handleTrophieModalOpen,
    handleSnack,
    showLoading,
    hideLoading,
  } = props;
  

  const isObjectFull = (array, values) => {
    if (array === values.laboralHolder) {
      if (array.slice(-1).pop().actualCompanyPosition === false) {
        const allValues = Object.values(array.slice(-1).pop())
        const filteredValues = allValues.filter(elem => elem !== false)
        const evaluation = filteredValues.every(elem => {
          if (elem !== '') {
            return true
          }
          return false
        })
        return evaluation;
      } else {
        const allValues = Object.values(array.slice(-1).pop())
        const slicedValues = allValues.slice(0, 5)
        const evaluation = slicedValues.every(elem => {
          if (elem !== '') {
            return true
          }
          return false
        })
        return evaluation;
      }
    } else {
      const allValues = Object.values(array.slice(-1).pop())
      const evaluation = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
      return evaluation;
    }
  }

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
    showLoading()

    let arrayValues = Object.values(values)
    const index = arrayValues.indexOf(8)
    if (index > -1) {
      arrayValues.splice(index, 1);
    }
    let boolValues = arrayValues.every(elem => elem) 
    
    const sliced = arrayValues.slice(11)
    sliced.some(elem => {
      if (isObjectFull(elem, values) === false) {
        boolValues = false
      }
    })

    if (boolValues === false) {
      handleRewarded(false)
    }

    editHolderFirm(
      uid,
      values,
      item,
      allHolders,
      boolValues,
    ).then(res => {
      if (alreadyRewarded === false) {
        handleTrophieModalOpen(trophie)
      }
      hideLoading();
      setTimeout(() => {
        setFlagEdit(0);
        scroller.scrollTo('myScroll_Holder', { smooth: true, offset: -64 });
        handleSnack();
      }, 2000);
    });  
    
  };

  const formValues = {
    flagEdit: 1,
    item: uid,
    imgProfileHolder: elements.imgProfileHolder,
    gender: elements.gender,
    email: elements.email,
    nameHolder: elements.nameHolder,
    firstLastname: elements.firstLastname,
    secondLastName: elements.secondLastName,
    gradeStudy: elements.gradeStudy,
    cedula: elements.cedula,
    specialties: elements.specialties,
    holderLanguages: elements.holderLanguages ? elements.holderLanguages : '',
    educationHolder: elements.educationHolder ? [...elements.educationHolder] : '',
    courses: elements.courses ? [...elements.courses] : '',
    certifications: elements.certifications ? [...elements.certifications] : '',
    awards: elements.awards ? [...elements.awards] : '',
    publications: elements.publications ? [...elements.publications] : '',
    laboralHolder: elements.laboralHolder ? [...elements.laboralHolder] : '',
  };

  const resetTab = () => {
    scroller.scrollTo('myScroll_Holder', { smooth: true, offset: -64 });
    evento(false);
  };

  const deleteHolder = item => {
    handleOpen();
  };

  const confirmDeleteHolder = event => {
    event.preventDefault()
    
    deleteHolderFirm(uid, item, allHolders).then(res => {
      hideLoading();
      handleSnack()
      resetTab();
    });
  };

  /* Modal */
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let fullName = elements.nameHolder.concat(
    ' ',
    elements.firstLastname.concat(' ', elements.secondLastName)
  );

  const status = {
    edit: 1
  }

  return (
    <>
      <Popup
        open={open}
        handleClose={handleClose}
        title={['Quieres eliminar de la', <br />, `lista, a ${fullName}?`]}
        subtitle='Si eliminas el perfil del abogado se perderan sus datos, tendrás que ingresar su información nuevamente para poder visualizarlo nuevamente.'
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, Eliminar'
        primaryFunction={confirmDeleteHolder}
        secondaryButton={true}
        secondaryButtonVariant='primary'
      />

      <div className="addHolders">
        <Formik
          initialValues={formValues}
          validationSchema={validationAddingHolder}
          onSubmit={handleSubmit}

          initialStatus={status}
          render={props => (
            <HolderForm
              {...props}
              emailDefault={true}
              evento={resetTab}              
              handleDeleteProfile={deleteHolder}
              item={item}
            />
          )}
        />
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  holders: state.authClient.holders,
  trophie: state.authClient.awardPerfil.holder,
});

const mapDispatchToProps = dispatch => ({
  editHolderFirm: (uid, values, fireBaseUrl, item, allHolders, boolValues) =>
    dispatch(editHolderFirm(uid, values, fireBaseUrl, item, allHolders, boolValues)),

  deleteHolderFirm: (uid, item, allHolders) =>
    dispatch(deleteHolderFirm(uid, item, allHolders)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditHolder);
